import axios from 'axios';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './login.css';


import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, Container, Stack, Typography } from '@mui/material';
import { googleCallback } from '../../services/api.js';
import { getUserDetails, useMicrosoftLogin } from '../../services/msalconfig.js';
import Loader from '../../utils/loader/Loader.jsx';



const Login = () => {
  const navigate = useNavigate()
  // const [input, setInput] = useState({
  //   username: "",
  //   password: "",
  // });
  
  // const [showpassword, setShowpassword] = useState(false)


  const ext_backend = process.env.REACT_APP_PORT_8000;
  const auth_backend = process.env.REACT_APP_PORT_8001;
  const privacy_policy = process.env.REACT_APP_PRIVACY_POLICY
  const terms_and_conditions = process.env.REACT_APP_TERMS_OF_SERVICE





  const [isLoading, setIsLoading] = useState(false)


  // extra


  // 19

  const loginControl = async (response) => {
    try {
      setIsLoading(true)
      
      localStorage.setItem('access_token', response.access_token);
      localStorage.setItem('refresh_token', response.refresh_token);
      localStorage.setItem('username', response.username);

      setIsLoading(false)
      toast("Login successful");
      navigate('/'); // Navigate after login
    } catch (error) {
      setIsLoading(false)
      toast.error("Login failed")
      console.error('Error:', error);
    }
  };



  // const handleAuthClick = () => {
  //   const redirectUri = ""
  //   // const redirectUri = chrome.identity.getRedirectURL();
  //   // console.log(redirectUri);
    

  //   // Construct the OAuth URL with `prompt=select_account`
  //   const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=token&scope=openid%20email%20profile&prompt=select_account`;

  //   // Open the OAuth flow
  //   // chrome.identity.launchWebAuthFlow({
  //   //   url: authUrl,
  //   //   interactive: true
  //   // }, function (redirectUrl) {
  //   //   if (chrome.runtime.lastError) {
  //   //     console.error('OAuth error:', chrome.runtime.lastError);
  //   //     return;
  //   //   }

  //   //   if (redirectUrl) {
  //   //     // Extract the access token from the URL
  //   //     const params = new URLSearchParams(redirectUrl.split('#')[1]);
  //   //     const accessToken = params.get('access_token');

  //   //     if (accessToken) {
  //   //       // Now you can send this token to your backend to store user info
  //   //       loginControl(accessToken);
  //   //     } else {
  //   //       console.log('No access token received');
  //   //     }
  //   //   }
  //   // });
  // };

  // Google Login 
  const handleGoogleLogin = async() => {
    try{
      const redirect_uri = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
      const response = await axios.get(`${auth_backend}google-login/?redirect_uri=${redirect_uri}`);
      if(response.status === 200){
        const { auth_url } = response.data;
        window.open(auth_url, '_blank',"width=500,height=600");
        const handleMessage = async (event) => {
              if (event.origin !== window.location.origin) return;
  
              if (event.data.type === "google-workspace-auth-success") {
                  window.removeEventListener("message", handleMessage);
  
                  const code = event.data.code;
                  const data  = await googleCallback(code)
                  
                                    
                  loginControl(data);
                  
                  
              }

          };
          window.addEventListener("message", handleMessage);
    }
  }
  catch(error){
    console.log(error);
    
  }
  }

  
  
  
  // window.addEventListener("message", (event) => {
  //   if (event.origin !== "http://localhost:3000") return; // Ensure only trusted origins send messages
  
  //   if (event.data.type === "AUTH_REQUEST") {
  //     const authUrl = "https://accounts.google.com/o/oauth2/auth?...";
  //     chrome.tabs.create({ url: authUrl });
  //   }
  // });

  // Password
  // const togglePassword = () => {
  //   setShowpassword(!showpassword)
  // }

  // For microsoft 17-11-2024
  const handleSuccess = async (data) => {

    try {
      if (data) {
        localStorage.setItem('picture', data.picture);
      }
      setIsLoading(true)
      await axios.post(`${ext_backend}auth/google/`, {
        email: data.email,
        name: data.name,
        display_name:data.name

      }).then((res) => {
        const { access, refresh } = res.data;

        setIsLoading(false)

        // Store tokens in localStorage or sessionStorage
        localStorage.setItem('access_token', access);
        localStorage.setItem('refresh_token', refresh);



        navigate('/')

      })
    } catch (error) {
      setIsLoading(false)
      console.log(error);

    }

  }

  const { getAccessToken } = useMicrosoftLogin();
  // const [user, setUser] = useState(null);

  const msLogin = async () => {
    const token = await getAccessToken();
    const userData = await getUserDetails(token);
    // setUser(userData);
    console.log(userData);
    handleSuccess({
      email: userData.mail || userData.userPrincipalName,
      name: userData.displayName || userData.givenName,
      picture: "",
    });
    
  };

  // const handleLogin = async() => {
  //     await instance.loginPopup(["openid", "profile", "User.Read"]).then((response)=>{
  //         console.log(response.account.username);
  //         handleSuccess({email:response.account.username,name:response.account.name})

  //     }).catch(e => {
  //         console.error(e);
  //     });
  // };



  // const handleLogin = ()=>{
  //   // chrome.runtime.sendMessage({ action: "microsoft_login" });
  //   console.log("some");
    
  // }

//   chrome.runtime.onMessage.addListener((message, sender, sendResponse) => {
//     if (message.action === "user_details") {
//         const userInfo = message.data;
//         handleSuccess({
//           email: userInfo.mail || userInfo.preferredLanguage,
//           name: userInfo.dispalyName || userInfo.givenName,
//           picture: "",
//         });
        
        
//     }
// });




  


  const dashboard = process.env.REACT_APP_DASHBOARD


  return (
    <>

      <div >
        

        {/* New code start */}
        {!isLoading ?
          <>
            
            <Container className='!px-0'>
              
              <Stack>
                <Typography className='!text-[22px] !leading-[28px] py-[40px]'>
                  Make meetings effortless with Lizy,<br /> your virtual assistant
                </Typography>
              </Stack>
              <Stack spacing={1} >
                <button onClick={handleGoogleLogin} className='flex justify-between border border-grey-200  p-2  px-4  !rounded-md  bg-white align-items-center'>
                  <i className="ci ci-google ci-2x p-2"></i>

                  <p className='text-black text-md fw-medium'>Sign in with Google</p>
                  
                  <ArrowForwardIcon/>
                </button>

                <button onClick={msLogin} className=' flex justify-between border border-grey-200  p-2  px-4  !rounded-md  bg-white align-items-center'>
                  <i className="ci ci-microsoft ci-2x p-2"></i>

                  <p className='text-black text-md fw-medium'>Sign in with Microsoft</p>
                  <ArrowForwardIcon/>
                </button>
              </Stack>
              <Stack className='px-3 py-[40px]'>
                <hr />
              </Stack>
              <Stack className='!text-[14px] text-center !leading-[28px] py-[4px]'>
                <Typography >
                  New to Liznr?
                </Typography>
              </Stack>
              <Stack>
                <Link to={dashboard} target='_blank'> 
                <Button className=' p-2 !text-[14px] w-full !normal-case !text-[#4F5B92]'>
                  Create your team
                </Button>
                </Link>
              </Stack>

              <Stack>
                <Typography className='!text-[12px]  !leading-[18px] pt-10'>
                  By signing up you agree to our <Link className="!text-[#4F5B92] underline" to={terms_and_conditions} target='_blank'>terms and conditions</Link>  and
                  <br/> 
                  <Link className="!text-[#4F5B92] underline" to={privacy_policy} target='_blank' >privacy policy.</Link>
                </Typography>
              </Stack>
            </Container>

          </> : <Loader />}

      </div>

    </>
  );
}

export default Login;